import React, { useState, useEffect } from 'react';
import { Segmented, Tooltip } from 'antd';
import { StyledTooltipIcon } from '../../styled';
import Sankey from './Chart';
import { StyledSankeyHeader } from './styled';
import { getSankeyData } from './utils';

const SankeyPanel = ({ data }) => {
  const [selected, setSelected] = useState<string>('kpiSampleSize');
  const [sankeyData, setSankeyData] = useState(null);

  useEffect(() => {
    const { impactAvoided, timeAvoided } = getSankeyData(data);
    if (selected === 'kpiSampleSize') {
      setSankeyData(impactAvoided);
    } else {
      setSankeyData(timeAvoided);
    }
  }, [selected, data]);

  return (
    <>
      <StyledSankeyHeader>
        <h3>
          CDN Resources & ISP - Impact Avoidance Breakdown
          <Tooltip title="Top 20">
            <StyledTooltipIcon />
          </Tooltip>
        </h3>
        <Segmented
          defaultValue={selected}
          options={[
            {
              label: 'KPI Sample Size',
              value: 'kpiSampleSize',
            },
            {
              label: 'Duration',
              value: 'duration',
            },
          ]}
          onChange={(value) => {
            setSelected(String(value));
          }}
        />
      </StyledSankeyHeader>
      <Sankey data={sankeyData} type={selected} />
    </>
  );
};

export default SankeyPanel;
